import dashboardWidget from './dashboardWidget'

export default class dashboardWidgetAverageTable extends dashboardWidget {

}
